export const primaryColor = "#226d30";

export const secondaryColor = "#add13f";

export const tertiaryColor = "#dee2df";

export const backgroundColor = "#fafafa";

export const textColor = "#000000";
